/* The attest pane beside the approvals queue. Paper, hairline, no shadow; tokens only (ADR-0007). */

.pane {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
  padding: 16px;
  border: 1px solid var(--line);
  border-radius: var(--radius-lg);
  background: var(--panel);
}

.head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.title {
  margin: 0;
  color: var(--ink);
  font-size: var(--t-head);
  font-weight: 650;
}

.meta {
  margin: 2px 0 0;
  color: var(--muted);
  font-size: var(--t-min);
}

.close {
  min-height: var(--h-ctl);
  padding: 0 12px;
  border: 1px solid var(--line-2);
  border-radius: var(--radius-ctl);
  background: var(--panel);
  color: var(--ink-2);
  font: inherit;
  font-size: var(--t-dense);
  cursor: pointer;
}

.close:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
}

.section {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
}

.sectionHead {
  margin: 0;
  color: var(--muted);
  font-size: var(--t-min);
  font-weight: 600;
}

.note {
  margin: 0;
  color: var(--ink-2);
  font-size: var(--t-dense);
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.links {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 16px;
  margin: 0;
}

.link {
  color: var(--accent);
  font-size: var(--t-dense);
  font-weight: 650;
  text-decoration: underline;
}

.link:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
}

.filing {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.verdict,
.stated {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 4px 10px;
  margin: 0;
}

.statedValue {
  color: var(--ink);
  font-size: var(--t-kpi);
  line-height: 1.05;
  font-variant-numeric: lining-nums tabular-nums;
}

.unit {
  color: var(--ink-2);
  font-size: var(--t-dense);
}

@media (max-width: 560px) {
  .close {
    min-height: var(--target-touch);
  }
}
